import { createSlice } from "@reduxjs/toolkit";
import ApiServices from "@/api/apexchat.api.services";
import { HostAPI } from "@/api/endpoints";

/**
 * @name @createSlice
 * @description create redux store slice for auth
 **/
export const countriesSlice = createSlice({
  name: "countries",
  initialState: {
    countries: [],
  },

  reducers: {
    setCountriesToState: (state, action) => {
      state.countries = action.payload;
    },
  },
});
export const { setCountriesToState } = countriesSlice.actions;

/**
 * These function called thunk and allows to perform async logic
 * It can be dispatched like a regular action: `dispatch(data)`
 **/

/* called a selector and allows to select values from the state */

export const selectCountries = (state) => {
  return state.countries;
};

export default countriesSlice.reducer;
